import { useNavigate } from "react-router-dom";
import Header from "../../../layouts/header/Header";
import { useEffect } from "react";
import { getCookie } from "../../../utils/utils";

const AdminRoot = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = getCookie("BscAdminToken");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);
  return (
    <div>
      <Header />
    </div>
  );
};

export default AdminRoot;
